import React, { Fragment } from 'react'
import PageLayout from './PageLayout'
import Helmet from 'react-helmet'
import map from 'lodash/map'
import SectionWidget from '../widgets/SectionWidget'
import Share from '../share/Share'
import { SECTIONS } from '../../utils/url'

export default (props) => {
    const { page, site, sitemap, className } = props
    const activeSection = page ? page.userSection : ''
    return (
        <PageLayout className={` ${className}  widgets-page `} activeSection={activeSection} inferSearchSection={activeSection !== SECTIONS.VISITOR.key} sitemap={sitemap}>
            {page && (
                <Fragment>
                    <Helmet>
                        <title>{page.title}</title>
                        {!!page.metaDescription && <meta name="description" content={page.metaDescription.metaDescription} />}
                    </Helmet>
                    <main className="wrapper flex-column container-fluid">
                        {map(page.sections, (section) => (
                            <section className={`section row ${section.fullWidth ? '' : 'narrow mt-0'}`} key={section.name}>

                                {section.showTitle && <h2 className="section-title">{section.name}</h2>}   
                                {map(section.widgets, (widget, index) => (
                                    <SectionWidget key={widget.contentful_id || index} widget={widget} activeSection={activeSection} fullWidth={section.fullWidth} />
                                ))}
                            </section>
                        ))}
                        {page.showSocialShare && (
                            <section className="section narrow mt-md-5">
                                <Share
                                    socialConfig={{
                                        twitterHandle: site.twitterHandle,
                                        config: {
                                            url: `${site.siteUrl}/${page.slug}`,
                                            title: `${site.title} - ${page.title}`,
                                        },
                                    }}
                                    tags={['Starship']}
                                />
                            </section>
                        )}
                    </main>
                </Fragment>
            )}
        </PageLayout>
    )
}
